// src/website/hooks/useEventData.js
import { useState, useEffect } from 'react';

export const useEventData = (identifier) => {
  console.log("useEventData identifier:", identifier);
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/event/website/published_events/${identifier}`
        );
        
        if (!response.ok) {
          throw new Error('Event not found');
        }
        
        const data = await response.json();
        setEventData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (identifier) {
      fetchEventData();
    }
  }, [identifier]);

  return { eventData, loading, error };
};